import React, { useCallback, useEffect, useState } from 'react';
import styles from './index.module.less';
import Avatar from '../../Avatar';
import { TagsNode } from '../../Tag';
import { joyspacePermissionType, TabKeyType } from '../../types';
import { DepIcon, getIcon } from '../../assets/icons/svg';
import { Checkbox } from 'antd';

export default function Item(props: any) {
  const {
    rightRenderDOM,
    owners = [],
    handleCheckbox,
    isChecked = false,
    myPermissionType,
    customItemStyle = {},
    hasCheckbox = true,
    showInheritText = false,
    inherited,
  } = props;
  const isShowHeritText = showInheritText && inherited;

  return (
    <div
      className={`${styles['joyspace-tab-item']} ${customItemStyle[
        'custom-tab-item'
      ] || ''}`}
    >
      <div className={styles['tab-item-left']}>
        {hasCheckbox && myPermissionType < joyspacePermissionType.ReadOnly && (
          <Checkbox
            style={{ marginRight: '16px' }}
            checked={isChecked}
            onChange={e =>
              handleCheckbox({
                selectedId: props.id,
                isChecked: e.target.checked,
              })
            }
            disabled={
              owners.some((owner: any) => owner.id === props.id) || inherited
            }
          />
        )}
        <Avatar
          avatar={props.avatar || props.avatarUrl}
          name={props.name}
          Icon={getIcon(props.type)}
        />
        <div
          className={`${styles['tab-item-info']} ${
            isShowHeritText ? styles['item-inherit-style'] : ''
          }`}
        >
          <div className={styles['tab-item-box']}>
            <p className={styles['tab-item-title']}>{props.name}</p>
            {TagsNode(props.labelInfoList)}
          </div>
          <p className={styles['tab-item-desc']}>{props.desc}</p>
        </div>
      </div>
      <div className={`${styles['tab-item-right']}`}>
        {isShowHeritText && (
          <span className={styles['tab-item-inherit']}>从父级页面继承</span>
        )}
        {rightRenderDOM?.()}
      </div>
    </div>
  );
}
